import { useRef } from "react";
import type { RouteResultForMapView, RoutingMode } from "../types/routing";
import { useRoutingService } from "./useRoutingService";
import { LocationInput } from "../types/routingInterface";

export const useCurrentRoute = () => {
  const currentRoute = useRef<RouteResultForMapView | null>(null);
  const routingService = useRoutingService();

  const searchRoute = async (
    start: LocationInput,
    goal: LocationInput,
    mode: RoutingMode = "default",
  ): Promise<RouteResultForMapView | null> => {
    currentRoute.current = await routingService.findPath(start, goal, mode);

    return currentRoute.current;
  };

  const clearRoute = () => {
    currentRoute.current = null;
  };

  const prepareRouting = () => routingService.warmUp();

  return {
    currentRoute: currentRoute,
    searchRoute,
    clearRoute,
    prepareRouting,
  };
};
